import { OPEN_CUSTOMER_CHAT_QUERY_KEY } from 'constants/constants';
import { IInternalDetailsLocationState } from 'types/global';

/**
 * Indica si la navegación debe abrir el modal lateral del chat cliente.
 * Usar `openCustomerChat=1` en query o `openCustomerChat` en location state.
 */
export const shouldOpenCustomerChatFromLocation = (
  search: string,
  state?: IInternalDetailsLocationState
): boolean => {
  if (state?.openCustomerChat) return true;

  return new URLSearchParams(search).get(OPEN_CUSTOMER_CHAT_QUERY_KEY) === '1';
};
